export enum CentrosDistribuicaoTypes {
  'LOAD_REQUEST' = '@centrosDistribuicao/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@centrosDistribuicao/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@centrosDistribuicao/LOAD_FAILURE',

  'CLEAN_MOVIENTRADA' = '@centrosDistribuicao/CLEAN_MOVIENTRADA',
}
export interface ICentrosDistribuicao {
  codCdd: number;
  nomeFantasia: string;
  contato: string;
}

export interface CentrosDistribuicaoState {
  readonly data: ICentrosDistribuicao[];
  readonly loading: boolean;
  readonly error: boolean;
}
